export default __webpack_public_path__ + "4d2cf1e6bf0ff0f060f73a14761162e9.png";